"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _inputs = require("../../styles/inputs");

var _containers = require("../containers");

var _ChevronDown = require("styled-icons/boxicons-regular/ChevronDown");

var _Check = require("styled-icons/boxicons-regular/Check");

var _Clear = require("styled-icons/material/Clear");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _default = function _default(_ref) {
  var inputRef = _ref.inputRef,
      flex = _ref.flex,
      label = _ref.label,
      footerText = _ref.footerText,
      error = _ref.error,
      width = _ref.width,
      options = _ref.options,
      defaultSelectedOptionId = _ref.defaultSelectedOptionId,
      onClickOption = _ref.onClickOption,
      onClear = _ref.onClear,
      _ref$isClearable = _ref.isClearable,
      isClearable = _ref$isClearable === void 0 ? true : _ref$isClearable,
      rightComponent = _ref.rightComponent,
      _ref$labelTextProps = _ref.labelTextProps,
      labelTextProps = _ref$labelTextProps === void 0 ? {} : _ref$labelTextProps,
      _ref$footerTextProps = _ref.footerTextProps,
      footerTextProps = _ref$footerTextProps === void 0 ? {} : _ref$footerTextProps,
      _ref$rightComponentPr = _ref.rightComponentProps,
      rightComponentProps = _ref$rightComponentPr === void 0 ? {} : _ref$rightComponentPr,
      _ref$isMulti = _ref.isMulti,
      isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
      noRightComponentBorder = _ref.noRightComponentBorder,
      allowPredictive = _ref.allowPredictive,
      _ref$scaledBoxProps = _ref.scaledBoxProps,
      scaledBoxProps = _ref$scaledBoxProps === void 0 ? {} : _ref$scaledBoxProps,
      inputProps = _objectWithoutPropertiesLoose(_ref, ["inputRef", "flex", "label", "footerText", "error", "width", "options", "defaultSelectedOptionId", "onClickOption", "onClear", "isClearable", "rightComponent", "labelTextProps", "footerTextProps", "rightComponentProps", "isMulti", "noRightComponentBorder", "allowPredictive", "scaledBoxProps"]);

  var _useState = (0, _react.useState)(false),
      isFocused = _useState[0],
      setIsFocused = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      dropdownDisplayed = _useState2[0],
      setDropdownDisplayed = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      predictive = _useState3[0],
      setPredictive = _useState3[1];

  var _useState4 = (0, _react.useState)(options ? options.find(function (_ref2) {
    var id = _ref2.id;
    return id === defaultSelectedOptionId;
  }) : null),
      selectedOption = _useState4[0],
      setSelectedOption = _useState4[1];

  var wrapperRef = (0, _react.useRef)(null);
  var newInputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    // Bind the event listener
    document.addEventListener("click", handleClickOutside, false);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  var handleClickOutside = function handleClickOutside(event) {
    if (wrapperRef && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setDropdownDisplayed(false);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_inputs.InputContainer, {
    ref: wrapperRef,
    width: width,
    flex: flex
  }, /*#__PURE__*/_react["default"].createElement(_inputs.InputLabel, labelTextProps, label), /*#__PURE__*/_react["default"].createElement(_inputs.ScaledBox, scaledBoxProps, /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    width: "100%",
    onClick: function onClick() {
      return options && setDropdownDisplayed(!dropdownDisplayed);
    }
  }, isMulti ? /*#__PURE__*/_react["default"].createElement(_inputs.Textarea, _extends({
    disabled: Boolean(options && options.length),
    dropdownDisplayed: dropdownDisplayed,
    hasRightComponent: Boolean(options || rightComponent),
    ref: inputRef || newInputRef,
    error: error,
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    }
  }, options ? {
    value: selectedOption && selectedOption.value || ""
  } : {}, inputProps)) : /*#__PURE__*/_react["default"].createElement(_inputs.InputBox, _extends({
    disabled: allowPredictive ? !allowPredictive : Boolean(options && options.length),
    dropdownDisplayed: dropdownDisplayed,
    hasRightComponent: Boolean(options || rightComponent),
    ref: inputRef || newInputRef,
    error: error,
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    },
    onChange: function onChange(value) {
      if (allowPredictive) {
        setPredictive(value.currentTarget.value);
        setSelectedOption();

        if (onClickOption) {
          onClickOption(value.currentTarget.value);
        }
      }
    }
  }, options ? {
    value: allowPredictive && predictive !== "" ? predictive : selectedOption && selectedOption.value || ""
  } : {}, inputProps)), options && /*#__PURE__*/_react["default"].createElement(_inputs.InputBoxRightComponentContainer, _extends({
    dropdownDisplayed: dropdownDisplayed,
    error: error,
    isFocused: isFocused
  }, rightComponentProps), selectedOption && isClearable && /*#__PURE__*/_react["default"].createElement(_containers.Container, {
    cursor: "pointer",
    width: "1.5rem",
    height: "1.5rem"
  }, /*#__PURE__*/_react["default"].createElement(_Clear.Clear, {
    size: "1.5rem",
    onClick: function onClick(e) {
      e.stopPropagation();
      setSelectedOption();

      if (onClear) {
        onClear();
      }
    }
  })), /*#__PURE__*/_react["default"].createElement(_inputs.InputClearAndDropdownSeparator, null), /*#__PURE__*/_react["default"].createElement(_containers.Container, {
    padding: "0 .6rem 0 0",
    cursor: "pointer",
    width: "2.4rem",
    height: "2rem"
  }, /*#__PURE__*/_react["default"].createElement(_ChevronDown.ChevronDown, {
    size: "2rem"
  }))), rightComponent && /*#__PURE__*/_react["default"].createElement(_inputs.InputBoxRightComponentContainer, {
    error: error,
    isFocused: isFocused,
    rightComponentProps: rightComponentProps,
    noRightComponentBorder: noRightComponentBorder
  }, rightComponent)), /*#__PURE__*/_react["default"].createElement(_containers.FlexColumn, {
    position: "relative"
  }, options && dropdownDisplayed && /*#__PURE__*/_react["default"].createElement(_inputs.InputDropdownOptionsContainer, {
    margin: "-0.5rem 0 0 0"
  }, options.filter(function (option) {
    if (allowPredictive) {
      return option.value.toUpperCase().startsWith(predictive.toUpperCase());
    } else {
      return option;
    }
  }).map(function (option) {
    var optionLabel = option.value;

    if (typeof option.value === "string") {
      optionLabel = option.value.replace(" ", "\xA0");
    }

    return /*#__PURE__*/_react["default"].createElement(_inputs.InputDropdownOption, {
      key: option.id,
      fontSize: inputProps.fontSize,
      onClick: function onClick() {
        setSelectedOption(option);
        setDropdownDisplayed(false);
        setPredictive("");

        if (onClickOption) {
          onClickOption(option);
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_inputs.InputDropdownOptionLabel, {
      flex: 1
    }, allowPredictive && /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontWeight: 700
      }
    }, optionLabel.substr(0, predictive.length)), allowPredictive ? optionLabel.substr(predictive.length, optionLabel.length) : optionLabel), selectedOption && selectedOption.id === option.id && /*#__PURE__*/_react["default"].createElement(_inputs.InputDropdownOptionCheck, {
      style: {
        width: "1.6rem",
        height: "1.6rem"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Check.Check, {
      size: "1.6rem"
    })));
  })), (error || footerText) && /*#__PURE__*/_react["default"].createElement(_inputs.InputFooterText, _extends({
    error: error
  }, footerTextProps), error ? error : footerText))));
};

exports["default"] = _default;
module.exports = exports["default"];